(() => {
  const initJournal = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const buttons = [...root.querySelectorAll('[data-journal-filter]')];
    const select = root.querySelector('[data-journal-filter-select]');
    const input = root.querySelector('[data-journal-search]');
    const searchToggle = root.querySelector('[data-journal-search-toggle]');
    const searchWrap = root.querySelector('[data-journal-search-wrap]');
    const items = [...root.querySelectorAll('[data-journal-article]')];
    const count = root.querySelector('[data-journal-result-count]');
    const empty = root.querySelector('[data-journal-empty]');
    let active = 'all';

    const refresh = () => {
      const query = (input?.value || '').trim().toLocaleLowerCase();
      let visible = 0;

      items.forEach((item) => {
        const categoryMatches = active === 'all' || item.dataset.category === active;
        const textMatches = !query || item.textContent.toLocaleLowerCase().includes(query);
        const show = categoryMatches && textMatches;
        item.hidden = !show;
        if (show) visible += 1;
      });

      if (count) {
        const label = visible === 1 ? count.dataset.singular : count.dataset.plural;
        count.textContent = `${visible} ${label}`;
      }
      empty?.classList.toggle('is-visible', visible === 0);
    };

    const setActive = (next) => {
      active = next || 'all';
      buttons.forEach((button) => {
        const selected = button.dataset.journalFilter === active;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      if (select) select.value = active;
      refresh();
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => setActive(button.dataset.journalFilter));
    });

    select?.addEventListener('change', () => setActive(select.value));
    input?.addEventListener('input', refresh);

    searchToggle?.addEventListener('click', () => {
      const open = !searchWrap?.classList.contains('is-open');
      searchWrap?.classList.toggle('is-open', open);
      searchToggle.setAttribute('aria-expanded', String(open));
      if (open) input?.focus();
    });

    input?.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      input.value = '';
      searchWrap?.classList.remove('is-open');
      searchToggle?.setAttribute('aria-expanded', 'false');
      searchToggle?.focus();
      refresh();
    });

    refresh();
  };

  const initAll = () => document.querySelectorAll('[data-hera-journal]').forEach(initJournal);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
